import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { setMessage } from "../message/messageSlice"
import api, { timeout } from "../../api"
import { toast } from "react-toastify"
import { convertBlobToBase64 } from "@/lib/util"

export const getbusinessdetail = createAsyncThunk(
  "profile/getbusinessdetail",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/business/info`)
      return response?.data
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const updatebusiness = createAsyncThunk(
  "profile/updatebusiness",
  async ({ inputData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(
        `abide/v1/business/business/update`,
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const deletebusiness = createAsyncThunk(
  "profile/deletebusiness",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`abide/v1/business/${id}`, {})
      return response?.data
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const uploadpassport = createAsyncThunk(
  "profile/uploadpassport",
  async ({ inputData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`abide/v1/document/logo`, inputData)
      return response?.data
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const getpassport = createAsyncThunk(
  "profile/getpassport",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/document/logo/${id}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const getRoles = createAsyncThunk(
  "profile/getRoles",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/profile/roles`)
      return response?.data
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const getprofileinfo = createAsyncThunk(
  "profile/getprofileinfo",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/profile/profile`)
      return response?.data
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const getProfilePicture = createAsyncThunk(
  "profile/getProfilePicture",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/document/dp/download`, {
        responseType: "blob",
      })
      if (response) {
        const base64String = await convertBlobToBase64(response.data)
        return base64String
      }
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const uploadprofilepicture = createAsyncThunk(
  "profile/uploadprofilepicture",
  async ({ inputData }, { dispatch, rejectWithValue }) => {
    try {
      let formdata = new FormData()
      formdata.append("file", inputData.data)
      const response = await api.post(`abide/v2/document/dp/upload`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      if (response) {
        toast.success("Profile picture changed successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const changepassword = createAsyncThunk(
  "profile/changepassword",
  async ({ inputData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(
        `abide/v1/profile/change-password`,
        inputData
      )
      if (response) {
        toast.success("Password changed successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const changedefaultbusiness = createAsyncThunk(
  "profile/changedefaultbusiness",
  async ({ code }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(
        `abide/v1/profile/default-account/${code}`,
        {}
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const updateprofile = createAsyncThunk(
  "profile/updateprofile",
  async ({ inputData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`abide/v1/profile/update`, inputData)
      if (response) {
        toast.success("Profile changed successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const enableMfa = createAsyncThunk(
  "profile/enableMfa",
  async ({ inputData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`abide/v1/profile/enable-mfa`, inputData)
      if (response) {
        toast.success("Password changed successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
const initialState = {
  photo: null,
  passport: null,
  roles: null,
  info: null,
  data: null,
  loading: false,
  error: false,
}

const profileSlice = createSlice({
  name: "profile",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getpassport.fulfilled, (state, { payload }) => {
      state.photo = payload
    })
    builder.addCase(getProfilePicture.fulfilled, (state, { payload }) => {
      state.passport = payload
    }),
      builder.addCase(getRoles.fulfilled, (state, { payload }) => {
        state.roles = payload.data
      })
    builder.addCase(getbusinessdetail.fulfilled, (state, { payload }) => {
      state.info = payload.data
    })
    builder.addCase(getprofileinfo.pending, (state) => {
      state.loading = true
      state.data = null
      state.error = false
    })
    builder.addCase(getprofileinfo.fulfilled, (state, { payload }) => {
      state.data = payload.data
      state.loading = false
      state.error = false
    })
    builder.addCase(getprofileinfo.rejected, (state) => {
      state.data = null
      state.loading = false
      state.error = true
    })
  },
})

export default profileSlice.reducer
